import { RootState } from '..';

export const userAddressesList = (state: RootState) => state.userAddress.items;

export const userSavedAddresses = (state: RootState) =>
  state.userAddress.selectedAddressId;
